import {Component, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';

import {FloorPlanDevice} from '../../../afb-api/models/floor';
import {Observable, combineLatest} from 'rxjs';
import {filter} from 'rxjs/operators';
import {OrganizationWithToken} from '../../../core/models/core';

import * as fromRoot from '../../../reducers';
import * as fromAfbApi from '../../../afb-api/reducers';
import * as fromFloorPlanEditor from '../../reducers';
import {FloorPlanSaveParams, ImageWithSource} from '../../models/floor-plan-editor-view';
import {SaveFloorPlan} from '../../actions/floor-plan-editor-view.actions';

@Component({
  selector: 'awair-floor-plan-editor-top',
  templateUrl: './floor-plan-editor-top.component.html',
  styleUrls: ['./floor-plan-editor-top.component.scss']
})

export class FloorPlanEditorTopComponent implements OnInit {

  selectedOrganization$: Observable<OrganizationWithToken> = this.rootStore.pipe(
    select(fromRoot.selectedOrganization),
    filter((selectedOrganization: OrganizationWithToken) => selectedOrganization != null)
  );
  deviceMarkersAsFloorPlanDevices$: Observable<FloorPlanDevice[]> = this.floorPlanEditorStore.pipe(
    select(fromFloorPlanEditor.deviceMarkersAsFloorPlanDevices),
    filter((floorPlanDevices: FloorPlanDevice[]) => floorPlanDevices != null)
  );
  selectedFloorId$: Observable<string> = this.floorPlanEditorStore.pipe(
    select(fromFloorPlanEditor.selectedFloorId)
  );
  uploadedImageWithSource$: Observable<ImageWithSource> = this.floorPlanEditorStore.pipe(
    select(fromFloorPlanEditor.uploadedImageWithSource)
  );
  didDeviceMarkerEntitiesChange$: Observable<boolean> = this.floorPlanEditorStore.pipe(
    select(fromFloorPlanEditor.didDeviceMarkerEntitiesChange)
  );
  didFloorImageChange$: Observable<boolean> = this.floorPlanEditorStore.pipe(
    select(fromFloorPlanEditor.didFloorImageChange)
  );

  saveParams$: Observable<FloorPlanSaveParams> = combineLatest(
    this.selectedOrganization$,
    this.deviceMarkersAsFloorPlanDevices$,
    this.selectedFloorId$,
    this.uploadedImageWithSource$,
    this.didDeviceMarkerEntitiesChange$,
    this.didFloorImageChange$,
    (selectedOrganization: OrganizationWithToken, devices: FloorPlanDevice[], floorId: string, uploadedImageWithSource: ImageWithSource,
     didDeviceMarkerEntitiesChange: boolean, didFloorImageChange: boolean) =>
      floorId != null ? {
        organizationToken: selectedOrganization.token,
        uploadedImageWithSource,
        devices,
        floorId,
        didDeviceMarkerEntitiesChange,
        didFloorImageChange
      } : null
  );

  saveFloorPlanLoading$: Observable<boolean> = this.floorPlanEditorStore.pipe(
    select(fromFloorPlanEditor.saveFloorPlanLoading)
  );
  isFloorPlanEdited$: Observable<boolean> = this.floorPlanEditorStore.pipe(
    select(fromFloorPlanEditor.isFloorPlanEdited)
  );

  constructor(private rootStore: Store<fromRoot.State>,
              private afbApiStore: Store<fromAfbApi.State>,
              private floorPlanEditorStore: Store<fromFloorPlanEditor.State>) {
  }

  ngOnInit() {
  }

  onSave(floorPlanSaveParams: FloorPlanSaveParams): void {
    this.floorPlanEditorStore.dispatch(new SaveFloorPlan(floorPlanSaveParams));
  }
}
